export default ({ app }, inject) => {
  // TODO: Set this to true when go live
  inject('webPos', true)
}
